import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import SweetenerComponentTable from './SweetenerComponentTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_NEW_TEXT, ADD_SWEETENER_COMPONENT_ROUTE, SWEETENER_COMPONENT_TEXT } from 'constants/index';

const SweetenerComponent: FC = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{SWEETENER_COMPONENT_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_SWEETENER_COMPONENT_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <SweetenerComponentTable />
    </Fragment>
  );
};

export default SweetenerComponent;
